import { getColorWithAlpha } from '@elfsight/lib-utils';
import { getInvertedColor } from '@elfsight/widget-utils';
import type { FormAppearance, ThemeSettings } from '../../../types';
import { defaultFormAppearance } from '../../constants';
import { getBorderRadius } from '../../utils';

export function getFormAppearanceSettings<T extends ThemeSettings>({
  cornerRadius,
  formAccentColor,
  formTextColor
}: T): FormAppearance {
  const { submitButtonProps } = defaultFormAppearance;
  const formBorderRadius = getBorderRadius(cornerRadius, {
    rounded: 8,
    circular: 24
  });

  return {
    ...defaultFormAppearance,
    fieldActiveColor: formAccentColor,
    fieldHeadingColor: formTextColor,
    fieldLabelColor: formTextColor,
    fieldColor: formTextColor,
    fieldHintColor: getColorWithAlpha(formTextColor, 0.7),
    fieldBorderRadius: formBorderRadius,
    fieldBorderColor: getColorWithAlpha(formTextColor, 0.2),
    submitMessageTitleColor: formTextColor,
    submitMessageTextColor: getColorWithAlpha(formTextColor, 0.5),
    submitMessageButtonColor: formAccentColor,
    submitButtonProps: {
      ...submitButtonProps,
      borderRadius: formBorderRadius,
      color: formAccentColor,
      fontColor: getInvertedColor(formAccentColor)
    },
    widgetFooterTextColor: getColorWithAlpha(formTextColor, 0.5),
    widgetFooterLinksColor: formAccentColor,
    fieldSpacing: 32
  };
}
